const state = {
    files: [],
    file: {},
    error: null,
    urlUpload: ""
};

export default state;
